import { Box, Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import FormFileDrop from '../../../FormFields/FormFileDrop';
import FormTitle from '../../../FormFields/FormTitle';
import { formCardStyle } from '../../../TransitionStyles';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { OPERATIONS } from '../../../formQuestionsEnum';

DocumentUploadsForm.propTypes = {
  permissions: PropTypes.object,
};

export default function DocumentUploadsForm({ permissions }) {
  const fieldIds = [
    OPERATIONS.LAST_3_ANNUAL_SURVEYS.id,
    OPERATIONS.LAST_3_YEARS_COMPLAINTS.id,
    OPERATIONS.CORPORATE_COMPLIANCE.id,
    OPERATIONS.NURSING_STAFFING_SCHEDULE.id,
    OPERATIONS.DIETARY_STAFFING_SCHEDULE.id,
    OPERATIONS.HOUSEKEEPING_STAFFING_SCHEDULE.id,
    OPERATIONS.LAUNDRY_STAFFING_SCHEDULE.id,
  ];

  const showForm = fieldIds.some((id) => id in permissions);

  const operationFields = [
    {
      id: OPERATIONS.LAST_3_ANNUAL_SURVEYS.id,
      fieldName: OPERATIONS.LAST_3_ANNUAL_SURVEYS.fieldName,
      fileTypeId: FILE_TYPES.ANNUAL_SURVEYS,
      questionTitle: 'Last three annual surveys',
    },
    {
      id: OPERATIONS.LAST_3_YEARS_COMPLAINTS.id,
      fieldName: OPERATIONS.LAST_3_YEARS_COMPLAINTS.fieldName,
      fileTypeId: FILE_TYPES.COMPLAINTS,
      questionTitle: 'Last three years complaints',
    },
    {
      id: OPERATIONS.CORPORATE_COMPLIANCE.id,
      fieldName: OPERATIONS.CORPORATE_COMPLIANCE.fieldName,
      fileTypeId: FILE_TYPES.CORPORATE_COMPLIANCE,
      questionTitle: 'Corporate compliance',
    },
    {
      id: OPERATIONS.NURSING_STAFFING_SCHEDULE.id,
      fieldName: OPERATIONS.NURSING_STAFFING_SCHEDULE.fieldName,
      fileTypeId: FILE_TYPES.NURSING_STAFFING_SCHEDULE,
      questionTitle: 'Nursing staffing schedule',
    },
    {
      id: OPERATIONS.DIETARY_STAFFING_SCHEDULE.id,
      fieldName: OPERATIONS.DIETARY_STAFFING_SCHEDULE.fieldName,
      fileTypeId: FILE_TYPES.DIETARY_STAFFING_SCHEDULE,
      questionTitle: 'Dietary staffing schedule',
    },
    {
      id: OPERATIONS.HOUSEKEEPING_STAFFING_SCHEDULE.id,
      fieldName: OPERATIONS.HOUSEKEEPING_STAFFING_SCHEDULE.fieldName,
      fileTypeId: FILE_TYPES.HOUSEKEEPING_STAFFING_SCHEDULE,
      questionTitle: 'Housekeeping staffing schedule',
    },
    {
      id: OPERATIONS.LAUNDRY_STAFFING_SCHEDULE.id,
      fieldName: OPERATIONS.LAUNDRY_STAFFING_SCHEDULE.fieldName,
      fileTypeId: FILE_TYPES.LAUNDRY_STAFFING_SCHEDULE,
      questionTitle: 'Laundry staffing schedule',
    },
  ];

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Document Uploads
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {operationFields.map((field) =>
            field.id in permissions ? (
              <Grid item xs={12} lg={4} key={field.id}>
                <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                  <FormTitle fieldAttributes={{ questionTitle: field.questionTitle, fieldType: 'file' }} />
                  <FormFileDrop
                    fieldName={field.fieldName}
                    fieldAttributes={{
                      isEditable: permissions[field.id],
                      fileTypeId: field.fileTypeId,
                    }}
                  />
                </Box>
              </Grid>
            ) : null
          )}
        </Grid>
      </Card>
    )
  );
}
